import Component from '../../../../../src/js/module/component';

class FloatingLabel extends Component {

    static componentName = 'floating-label';

    static componentSelector = '.js-floating-label';

    static defaultOptions = {
        formfield: '.c-form-field:not(.c-form-field--static)',
        activeClass: 'is-active',
    };

    constructor() {
        super(...arguments);

        ['update', 'updateAll'].forEach((fn) => {
            this[fn] = this[fn].bind(this);
        });

        this.$$element
            .addClass('is-js-on')
            .on('change', ({ target }) => {
                this.update(target);
            })
            .on('reset', () => {
                setTimeout(this.updateAll, 0);
            });
        this.updateAll();
    }

    update(target) {
        FloatingLabel.$$(target)
            .callAll('closest', this.options.formfield)
            .filter((element) => element)
            .toggleClass(this.options.activeClass, !!target.value);
    }

    updateAll() {
        FloatingLabel.$$(this.options.formfield)
            .query('input, select, textarea').forEach((elem) => {
                this.update(elem);
            });
    }

}

FloatingLabel.register();
